import type { UseQueryOptions } from "@tanstack/react-query";

import { useApiQuery } from "@/hooks/api/use-api-query";
import type { ApiError } from "@/lib/api-client";

export type TenantCdrsResponse = {
  data: Array<{
    id: string;
    callerIdName: string | null;
    callerIdNumber: string | null;
    destinationNumber: string | null;
    context: string | null;
    startStamp: string | null;
    answerStamp: string | null;
    endStamp: string | null;
    duration: number | null;
    billsec: number | null;
    hangupCause: string | null;
    uuid: string | null;
    organizationUuid: string | null;
  }>;
  total: number;
  pagination: {
    limit: number;
    offset: number;
  };
};

type TenantCdrsFilters = {
  tenantId?: string;
  page?: number;
  pageSize?: number;
  search?: string;
  startDate?: string;
  endDate?: string;
};

export function useTenantCdrsQuery(
  {
    tenantId,
    page = 0,
    pageSize = 50,
    search,
    startDate,
    endDate,
  }: TenantCdrsFilters,
  options?: Omit<
    UseQueryOptions<TenantCdrsResponse, ApiError>,
    "queryKey" | "queryFn"
  >
) {
  const limit = pageSize;
  const offset = page * pageSize;

  return useApiQuery<TenantCdrsResponse, ApiError>({
    queryKey: [
      "tenant-cdrs",
      tenantId,
      { page, pageSize, search, startDate, endDate },
    ],
    path: tenantId ? `/api/organizations/${tenantId}/cdrs` : "",
    request: {
      params: {
        limit: limit.toString(),
        offset: offset.toString(),
        search,
        startDate,
        endDate,
      },
    },
    queryOptions: {
      enabled: Boolean(tenantId) && (options?.enabled ?? true),
      ...options,
    },
  });
}
